import React from 'react';
import { useNavigate } from 'react-router-dom';
import { logout } from '../../services/authService';
import { useAuth } from '../../hooks/useAuth';
import './Home.css';

function Home() {
  const navigate = useNavigate();
  const { userData, isLoading } = useAuth();

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  if (isLoading) {
    return (
      <div className="home-loading">
        <div className="home-loading-spinner"></div>
        <p>Загрузка...</p>
      </div>
    );
  }

  if (!userData) {
    return (
      <div className="home-error">
        <span className="home-error-icon">⚠️</span>
        <h2>Данные пользователя недоступны</h2>
        <p>Пожалуйста, войдите снова</p>
        <button onClick={() => navigate('/login')} className="home-btn-primary">
          Войти
        </button>
      </div>
    );
  }

  return (
    <div className="home-container">
      {/* Welcome Card */}
      <div className="home-welcome-card">
        <div className="home-avatar">
          {userData.full_name ? userData.full_name.charAt(0).toUpperCase() : '👤'}
        </div>
        <div className="home-user-info">
          <h1 className="home-greeting">
            Добро пожаловать, <span className="home-name">{userData.full_name}!</span>
          </h1>
          <p className="home-username">
            <span className="home-label">Имя пользователя:</span> {userData.username}
          </p>
        </div>
        <button onClick={handleLogout} className="home-btn-logout">
          <span>🚪</span>
          Выйти
        </button>
      </div>

      {/* Quick Stats */}
      <div className="home-stats">
        <div className="home-stat-card">
          <div className="home-stat-icon">📦</div>
          <div className="home-stat-content">
            <h3>Заказы</h3>
            <p>Управление заказами</p>
          </div>
        </div>
        <div className="home-stat-card">
          <div className="home-stat-icon">🍔</div>
          <div className="home-stat-content">
            <h3>Продукты</h3>
            <p>Меню и товары</p>
          </div>
        </div>
        <div className="home-stat-card">
          <div className="home-stat-icon">🏢</div>
          <div className="home-stat-content">
            <h3>Организации</h3>
            <p>Филиалы и экраны</p>
          </div>
        </div>
        <div className="home-stat-card">
          <div className="home-stat-icon">👥</div>
          <div className="home-stat-content">
            <h3>Роли</h3>
            <p>Права доступа</p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Home;
